import { Component, Input } from '@angular/core';
import { Cms } from '@impact/data';

@Component({
    selector: 'app-vehicle-energy-ratings',
    template: `
        <p
            class="vehicle-energy-rating__header"
            [innerText]="'car_data.energy_rating_text' | translate"
        ></p>
        
        <div class="vehicle-energy-ratings">
            <div
                class="vehicle-energy-rating"
                [ngSwitch]="item.uniqueID"
                [title]="item.name"
                *ngFor="let item of data"
            >
                <svg
                    class="svg-energy-rating-aaaa svg-icon"
                    viewBox="0 0 106 36"
                    *ngSwitchCase="'AAAA'"
                >
                    <path fill="#00A651" d="M0 0v36h83.01l22.11-18L83.01 0z" />
                    <path
                        fill="#FFF"
                        d="M21.33 23.5h-6.07l-.84 2.86H8.95l6.5-17.31h5.83l6.5 17.31h-5.6l-.85-2.86zm-1.11-3.74l-1.91-6.22-1.89 6.22h3.8zM28.67 11.9h2.62V9.26h2.21v2.63h2.63v2.21H33.5v2.62h-2.21V14.1h-2.62v-2.2zM38.26 11.9h2.62V9.26h2.21v2.63h2.63v2.21h-2.63v2.62h-2.21V14.1h-2.62v-2.2zM47.85 11.9h2.62V9.26h2.21v2.63h2.63v2.21h-2.63v2.62h-2.21V14.1h-2.62v-2.2z"
                    />
                </svg>

                <svg
                    class="svg-energy-rating-aaa svg-icon"
                    viewBox="0 0 106 36"
                    *ngSwitchCase="'AAA'"
                >
                    <path fill="#51B848" d="M0 0v36h83.01l22.11-18L83.01 0z" />
                    <path
                        fill="#FFF"
                        d="M21.33 23.5h-6.07l-.84 2.86H8.95l6.5-17.31h5.83l6.5 17.31h-5.6l-.85-2.86zm-1.11-3.74l-1.91-6.22-1.89 6.22h3.8zM28.67 11.9h2.62V9.26h2.21v2.63h2.63v2.21H33.5v2.62h-2.21V14.1h-2.62v-2.2zM38.26 11.9h2.62V9.26h2.21v2.63h2.63v2.21h-2.63v2.62h-2.21V14.1h-2.62v-2.2z"
                    />
                </svg>

                <svg
                    class="svg-energy-rating-aa svg-icon"
                    viewBox="0 0 106 36"
                    *ngSwitchCase="'AA'"
                >
                    <path fill="#BED730" d="M0 0v36h83.01l22.11-18L83.01 0z" />
                    <path
                        fill="#FFF"
                        d="M21.33 23.5h-6.07l-.84 2.86H8.95l6.5-17.31h5.83l6.5 17.31h-5.6l-.85-2.86zm-1.11-3.74l-1.91-6.22-1.89 6.22h3.8zM28.67 11.9h2.62V9.26h2.21v2.63h2.63v2.21H33.5v2.62h-2.21V14.1h-2.62v-2.2z"
                    />
                </svg>

                <svg
                    class="svg-energy-rating-a svg-icon"
                    viewBox="0 0 106 36"
                    *ngSwitchCase="'A'"
                >
                    <path fill="#FFF200" d="M0 0v36h83.01l22.11-18L83.01 0z" />
                    <path
                        fill="#FFF"
                        d="M21.33 23.5h-6.07l-.84 2.86H8.95l6.5-17.31h5.83l6.5 17.31h-5.6l-.85-2.86zm-1.11-3.74l-1.91-6.22-1.89 6.22h3.8z"
                    />
                </svg>

                <svg
                    class="svg-energy-rating-b svg-icon"
                    viewBox="0 0 106 36"
                    *ngSwitchCase="'B'"
                >
                    <path fill="#FDB813" d="M0 0v36h83.01l22.11-18L83.01 0z" />
                    <path
                        fill="#FFF"
                        d="M10.7 9.05h10.01c1.67 0 2.95.41 3.84 1.24.89.83 1.34 1.85 1.34 3.07 0 1.02-.32 1.9-.96 2.63-.43.49-1.05.87-1.87 1.16 1.24.3 2.16.81 2.75 1.54.59.73.88 1.64.88 2.75 0 .9-.21 1.7-.63 2.42-.42.72-.99 1.28-1.71 1.7-.45.26-1.13.45-2.03.57-1.2.16-2 .24-2.4.24H10.7V9.05zm5.39 6.79h2.33c.83 0 1.41-.14 1.74-.43.33-.29.49-.7.49-1.25 0-.5-.16-.9-.49-1.18-.33-.28-.9-.42-1.71-.42h-2.36v3.28zm0 6.8h2.73c.92 0 1.57-.16 1.95-.49.38-.33.57-.76.57-1.32 0-.51-.19-.92-.56-1.23-.37-.31-1.03-.47-1.97-.47h-2.72v3.51z"
                    />
                </svg>

                <svg
                    class="svg-energy-rating-c svg-icon"
                    viewBox="0 0 106 36"
                    *ngSwitchCase="'C'"
                >
                    <path fill="#F37021" d="M0 0v36h83.01l22.11-18L83.01 0z" />
                    <path
                        fill="#FFF"
                        d="M22.21 19.27l4.69 1.42c-.31 1.31-.81 2.41-1.49 3.29a6.54 6.54 0 01-2.52 2c-1 .45-2.28.67-3.83.67-1.88 0-3.42-.27-4.61-.82-1.19-.55-2.22-1.51-3.09-2.88s-1.3-3.14-1.3-5.29c0-2.86.76-5.06 2.28-6.6 1.52-1.54 3.68-2.31 6.46-2.31 2.18 0 3.89.44 5.14 1.32 1.25.88 2.17 2.24 2.78 4.06L22 15.18c-.17-.53-.34-.91-.52-1.16-.3-.41-.67-.72-1.1-.94-.43-.22-.92-.33-1.45-.33-1.21 0-2.14.49-2.79 1.46-.49.72-.73 1.86-.73 3.41 0 1.92.29 3.23.87 3.94.58.71 1.4 1.07 2.46 1.07 1.02 0 1.8-.29 2.32-.86.53-.57.91-1.4 1.15-2.5z"
                    />
                </svg>

                <svg
                    class="svg-energy-rating-d svg-icon"
                    viewBox="0 0 106 36"
                    *ngSwitchCase="'D'"
                >
                    <path fill="#ED1C24" d="M0 0v36h83.01l22.11-18L83.01 0z" />
                    <path
                        fill="#FFF"
                        d="M10.76 9.05h7.95c1.57 0 2.83.21 3.8.64.96.42 1.76 1.03 2.39 1.83.63.8 1.09 1.72 1.37 2.77.28 1.06.42 2.17.42 3.35 0 1.85-.21 3.28-.63 4.3a7.198 7.198 0 01-1.75 2.56c-.75.69-1.55 1.15-2.41 1.38-1.17.32-2.24.47-3.19.47h-7.95V9.05zm5.34 3.92v9.46h1.31c1.12 0 1.91-.12 2.38-.37s.84-.68 1.11-1.3c.27-.62.4-1.62.4-3 0-1.83-.3-3.09-.9-3.77s-1.59-1.02-2.98-1.02H16.1z"
                    />
                </svg>

                <svg
                    class="svg-energy-rating-e svg-icon"
                    viewBox="0 0 106 36"
                    *ngSwitchCase="'E'"
                >
                    <path fill="#ED1C24" d="M0 0v36h83.01l22.11-18L83.01 0z" />
                    <path
                        fill="#FFF"
                        d="M10.67 9.05H25v3.7h-8.97v2.75h8.32v3.53h-8.32v3.41h9.23v3.92H10.67V9.05z"
                    />
                </svg>

                <svg
                    class="svg-energy-rating-f svg-icon"
                    viewBox="0 0 106 36"
                    *ngSwitchCase="'F'"
                >
                    <path fill="#ED1C24" d="M0 0v36h83.01l22.11-18L83.01 0z" />
                    <path
                        fill="#FFF"
                        d="M10.71 9.05h13.22v3.72h-7.85v3.02h6.71v3.49h-6.71v7.07h-5.37V9.05z"
                    />
                </svg>

                <svg
                    class="svg-energy-rating-g svg-icon"
                    viewBox="0 0 106 36"
                    *ngSwitchCase="'G'"
                >
                    <path fill="#ED1C24" d="M0 0v36h83.01l22.11-18L83.01 0z" />
                    <path
                        fill="#FFF"
                        d="M19.39 20.09v-3.6h8.26v7.38c-1.58 1.08-2.98 1.81-4.2 2.2-1.22.39-2.66.58-4.33.58-2.05 0-3.73-.35-5.02-1.05-1.29-.7-2.3-1.74-3.01-3.13s-1.07-2.98-1.07-4.77c0-1.89.39-3.53 1.17-4.93.78-1.4 1.92-2.46 3.42-3.18 1.17-.56 2.75-.84 4.73-.84 1.91 0 3.34.17 4.29.52.95.35 1.74.88 2.36 1.61.63.73 1.1 1.65 1.41 2.77l-5.16.92c-.21-.65-.57-1.15-1.08-1.5-.51-.35-1.16-.52-1.94-.52-1.17 0-2.11.41-2.8 1.22-.7.81-1.04 2.1-1.04 3.87 0 1.87.35 3.21 1.06 4.01.7.8 1.69 1.21 2.95 1.21.6 0 1.17-.09 1.71-.26s1.16-.47 1.87-.89v-1.63h-3.58z"
                    />
                </svg>
            </div>
        </div>
    `,
})
export class VehicleEnergyRatingsComponent {
    @Input() data: Cms.EnergyClass[];
}
